export default {
  "unit price":
    "The amount the supplier charges per unit of energy bought. Typically this unit is one kWh (kilowatt-hour)",
  "export rates":
    "The amount the supplier pays back per unit of energy when the energy generated in the home is higher than the energy consumed. This excess energy is sold to the grid and the user is compensated for it. Typically the unit of energy is one kWh (kilowatt-hour).",
  "generation rates":
    "The amount paid to the user per unit of generated energy, even if the user consumed it. Typically the unit of energy is one kWh (kilowatt-hour). This rate is quite rare, and only houses that installed solar panels during a certain period benefit from it. New installations no longer qualify for this rate.",
};
